const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
  FLOW: '/flow'
};

// ----------------------------------------------------------------------

export const paths = {
  // PUBLIC
  privacy: '/privacy',

  // AUTH
  auth: {
    signIn: `${ROOTS.AUTH}/sign-in`,
    signUp: `${ROOTS.AUTH}/sign-up`
  },

  flow: {
    root: ROOTS.FLOW,
    web: {
      root: `${ROOTS.FLOW}/web`
    },
    desktop: {
      root: `${ROOTS.FLOW}/desktop`,
      signIn: `${ROOTS.FLOW}/desktop/sign-in`,
      conflict: `${ROOTS.FLOW}/desktop/conflict`,
      uploadBackup: `${ROOTS.FLOW}/desktop/upload-backup`
    }
  },

  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    farm: {
      root: ROOTS.DASHBOARD,
      backup: `${ROOTS.DASHBOARD}/farm/backup`
    }
  }
};
